/* eslint-disable */
export default {
  ru: {},
  uk: {},
  en: {
    'card': 'Card',
    'liqpay': 'Liqpay',
    'privat24': 'Privat24',
    'masterpass': 'Masterpass',
    'creditcard': 'Credit card',
    'webmoneytransfer': 'Webmoney transfer',
    'easypay': 'Easypay',
    'privatbank_ssk': 'Privatbank terminals',
    'bitcoin': 'Bitcoin',
    'bitcoin_cash': 'Bitcoin cash',
    'visa_mastercard': 'Visa/Mastercard',
    'credit': 'Credit card',
    'walletone': 'Wallet One',
    'yandexmoney': 'Yandex money',
    'qiwi': 'Qiwi',
    'bpay': 'Bpay',
    'cashu': 'CashU',
    'googlewallet': 'Google Wallet',
    'okpay': 'Okpay',
    'kviku': 'Kviku',
    'beeline': 'Beeline',
    'mts': 'MTS',
    'megafon': 'Megafon',
    'tele2ru': 'Tele2 Russia',
    'yota': 'Yota',
    'kievstar': 'Kievstar',
    'ssk_ua': 'Self-Service kiosk Ukraine',
    'ssk_by': 'Self service kiosk Belarus',
    'ssk_ge': 'Self service kiosk Georgia',
    'ssk_kz': 'Self service kiosk Kazakhstan',
    'ssk_md': 'Self service kiosk Moldova',
    'ssk_ru': 'Self service kiosk Russia',
    'ssk_tj': 'Self service kiosk Tajikistan',
    'ssk_za': 'Self service kiosk South Africa',

    'euroset': 'Euroset',
    'svyaznoy': 'Svyaznoy',
    'cifrograd': 'Cifrograd',
    'cellularworld': 'Cellular World',
    'sbrebank': 'Sberbank',
    'promsvyazbank': 'Promsvyazbank',
    'sberonline': 'Sberbank Online',
    'privatbank': 'Privatbank',
    'pravexbank': 'Pravex Bank',
    'ukrsibbank': 'Ukrsib Bank',
    'qazkombank': 'Quazkom Bank',
    'libertybank': 'Liberty Bank',
    'russianpost': 'Russian Post',
    'lider': 'Lider',
    'unistream': 'Unistream',
    'alfaclick': 'Alfaclick',
    'tinkoff': 'Tinkoff',
    'psbretail': 'PSB-Retail',
    'fakturaru': 'Faktura.ru',
    'russian_standart_bank': 'Russian Standard Bank',
    'erip': 'Erip',
    'standartbank': 'Standard Bank',
    'banktransfer': 'Bank Transfer',
    'perfetctmoney_account': 'Perfect Money Account',
    'perfetctmoney_voucher': 'Perfect Money Voucher',
    selcom: 'Selcom',
  }
};